var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21,
    stroke: "#FCF7F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2212 16H24.9549C24.0094 16 23.2402 16.7692 23.2402 17.7146V21.739H24.8055V17.7146C24.8055 17.6323 24.8725 17.5652 24.9549 17.5652H38.2212C38.3036 17.5652 38.3707 17.6323 38.3707 17.7146V30.981C38.3707 31.0634 38.3036 31.1305 38.2212 31.1305H34.3223V32.6957H38.2212C39.1667 32.6957 39.9359 31.9265 39.9359 30.981V17.7146C39.9358 16.7692 39.1667 16 38.2212 16Z",
    fill: "#606062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0435 23.3057H17.7772C16.8317 23.3057 16.0625 24.0749 16.0625 25.0204V38.2867C16.0626 39.2322 16.8317 40.0014 17.7772 40.0014H31.0436C31.9891 40.0014 32.7583 39.2322 32.7583 38.2868V25.0204C32.7583 24.0749 31.989 23.3057 31.0435 23.3057ZM31.0436 38.4362H17.7772C17.6948 38.4362 17.6277 38.3692 17.6277 38.2868V25.0204C17.6277 24.9379 17.6948 24.8709 17.7772 24.8709H31.0436C31.126 24.8709 31.193 24.9379 31.193 25.0204V38.2868H31.1931C31.1931 38.3692 31.126 38.4362 31.0436 38.4362Z",
    fill: "#606062"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_12",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 0 0.313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_12",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.cc121839b4ae7c4a57ba8f35b5707bf7.svg";
export { ForwardRef as ReactComponent };